import { useMemo } from 'react';
import mastercardIMG from '@/assets/imgs/logos/mastercard.svg';
import { Error, Image } from '@/components/generic';
import { temporaryTiers } from '@/constants';
import { formatCardNumber, formatExpiryDate } from '@/utils';

type CreditCardProps = {
  cardInfo?: {
    cardNumber?: string;
    tier?: string;
  };
  sensitiveData?: {
    cvv?: string;
    validPeriod?: string;
  };
  isCanceled?: boolean;
  disabled?: boolean;
};

export const CreditCard = ({
  cardInfo,
  sensitiveData,
  isCanceled = false,
  disabled = false,
}: CreditCardProps) => {
  const isDisabled = useMemo(
    () => disabled || isCanceled || cardInfo?.cardNumber === undefined,
    [disabled, isCanceled, cardInfo?.cardNumber],
  );

  return (
    <div className='relative transition-transform transform  overflow-hidden max-w-[500px]  justify-self-center'>
      <Image
        src={
          temporaryTiers[
            (cardInfo?.tier as keyof typeof temporaryTiers) || 'Tier 0'
          ]?.img
        }
      />
      <Error
        error={isCanceled && !disabled}
        message={`This card (${formatCardNumber(cardInfo?.cardNumber)}) is canceled.`}
        className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-200 text-center'
      />
      <div
        className={`w-full absolute top-0 left-0  h-full  p-8  flex flex-col justify-between ${isDisabled ? 'blur-sm' : ''}`}
      >
        <div className='flex justify-between'>
          <div className='mt-8'>
            <p className='text-caption text-shade-10'>Card Number</p>
            <p className='font-medium tracking-more-wider text-shade-10'>
              {formatCardNumber(cardInfo?.cardNumber)}
            </p>
          </div>
          <Image className='w-10 h-10' src={mastercardIMG} />
        </div>
        <div className='pr-10 '>
          <div className='flex justify-start gap-12'>
            <div className=''>
              <p className='text-caption font-bold uppercase text-shade-10'>
                Expiry
              </p>
              <p className='font-bold text-sm text-shade-10'>
                {formatExpiryDate(sensitiveData?.validPeriod)}
              </p>
            </div>
            <div className=''>
              <p className='text-caption font-bold uppercase text-shade-10'>
                CVV
              </p>
              <p className='font-bold text-sm text-shade-10'>
                {sensitiveData?.cvv || 'xxx'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
